import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'vendor/angular-qrcode'

import fileUploadComponent from 'file-upload';
import moreTabsComponent from 'more-tabs';
import uploadAttachmentComponent from 'upload-attachment';
import taskDetailInfoComponent from './task-detail-info.component';

let taskDetailInfoModule = angular.module('taskDetailInfo', [
  uiRouter,
  'monospaced.qrcode',
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.tasks.task-detail.info', {
        url: '/information',
        template: '<task-detail-info task="$resolve.task" class="task-detail-info"></task-detail-info>',
      });
  })
  .component('fileUpload', fileUploadComponent)
  .component('moreTabs', moreTabsComponent)
  .component('uploadAttachment', uploadAttachmentComponent)
  .component('taskDetailInfo', taskDetailInfoComponent);

export default taskDetailInfoModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-info/index.js